/**
 * Thin wrapper around @bufferapp/buffer-js-api
 */

import BufferAPI from '@bufferapp/buffer-js-api';
import RPCClient from './RPCClient';

class API extends BufferAPI {
  static request(url, data = {}, settings) {
    return RPCClient.call('composerApiProxy', {
      url: `/1/${url}`,
      args: data,
      HTTPMethod: settings.method,
    });
  }
}

export default API;
